import React from 'react';
import { Pressable } from 'react-native';
import { useAppStore } from '@restorant/core';
import { radius, useColors, useThemeMode } from '../theme';
import { useT } from '../i18n';
import { Icon } from '../icons/Icon';
import { T } from './Text';

/** Flips between the light and dark palettes. Light is the default. */
export function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const colors = useColors();
  const t = useT();
  const mode = useThemeMode();
  const toggleTheme = useAppStore((s) => s.toggleTheme);

  const dark = mode === 'dark';

  return (
    <Pressable
      onPress={toggleTheme}
      testID="theme-toggle"
      accessibilityRole="switch"
      accessibilityState={{ checked: dark }}
      accessibilityLabel={t('theme')}
      style={({ hovered }: any) => ({
        flexDirection: 'row',
        alignItems: 'center',
        gap: 7,
        paddingVertical: 8,
        paddingHorizontal: compact ? 9 : 12,
        borderRadius: radius.pill,
        borderWidth: 1,
        borderColor: hovered ? colors.gold : colors.line,
        backgroundColor: colors.surface,
      })}
    >
      {/* Shows what tapping switches TO, which is the usual convention. */}
      <Icon name={dark ? 'sun' : 'moon'} size={15} color={colors.textDim} />
      {compact ? null : (
        <T size={12.5} weight={700} color={colors.textDim}>
          {t(dark ? 'theme_light' : 'theme_dark')}
        </T>
      )}
    </Pressable>
  );
}
